import { MarketingPage } from "@/components/marketing/MarketingPage";
import { PAGE_BANNERS } from "@/lib/assets";
import { ArrowRight } from "lucide-react";

const STEPS = [
  { n: "01", t: "Course SLOs → skills", d: "Each course's Student Learning Outcomes are weight-mapped onto the 10 transferable skills. A statistics SLO feeds Data Literacy; a team studio feeds Collaborative Leadership." },
  { n: "02", t: "Skills → domains", d: "Skill scores average within each of the 3 domains — Execution, Cognitive, and Growth — producing a domain score on the 1.0–4.0 scale." },
  { n: "03", t: "Domains → TSB", d: "Domains roll up with defined weights (34% / 34% / 32%) into one overall Transferable Skills Benchmark, shown as both 1.0–4.0 and 0–100." },
  { n: "04", t: "TSB → career alignment", d: "The profile is compared against each career's skill-demand profile to produce an alignment %, plus concrete strengths and gaps." },
];

export default function HowItWorks() {
  return (
    <MarketingPage
      eyebrow="How TSB Works"
      banner={PAGE_BANNERS.tsb}
      title="From a syllabus to a benchmark you can trust"
      lead="Nothing here is faked. The scoring engine, career-alignment engine, and what-if simulator all run on real computation over a swappable data layer — mock data today, D2L/Brightspace tomorrow."
    >
      <div className="space-y-5">
        {STEPS.map((s, i) => (
          <div key={s.n} className="flex gap-5 rounded-2xl border border-slate-200 bg-white p-6 card-elevate">
            <div className="font-mono-num text-3xl font-bold text-[#78be21]">{s.n}</div>
            <div>
              <h3 className="font-heading text-xl font-bold text-[#003057]">{s.t}</h3>
              <p className="mt-1 text-slate-600">{s.d}</p>
            </div>
            {i < STEPS.length - 1 && <ArrowRight className="ml-auto hidden h-6 w-6 self-center text-slate-300 sm:block" />}
          </div>
        ))}

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <div className="rounded-2xl bg-[#78be21]/10 p-6">
            <h3 className="font-heading text-lg font-bold text-[#003057]">Employer 360 — a separate signal</h3>
            <p className="mt-2 text-sm text-slate-700">
              Employer reviews form an <strong>individually-weighted, clearly-labeled, traceable and reversible</strong> signal.
              They blend at 25% toward reviewed skills and never silently overwrite coursework-derived scores. Every change is audited.
            </p>
          </div>
          <div className="rounded-2xl bg-slate-100 p-6">
            <h3 className="font-heading text-lg font-bold text-[#003057]">Personality stays out of the score</h3>
            <p className="mt-2 text-sm text-slate-700">
              Personality typing never enters the TSB. At most it appears as an optional soft “work-style” tag,
              so it can’t dilute the research-backed benchmark.
            </p>
          </div>
        </div>
      </div>
    </MarketingPage>
  );
}
